export default {
  data() {
    return {
      svgRoot: null
    }
  },
  methods: {
    initHierarchy() {
      if (!this.svgRoot) return

      const allPaths = Array.from(this.svgRoot.querySelectorAll('path[id]'))
      if (allPaths.length === 0) return

      const tischNodes = new Set()
      allPaths.forEach(path => {
        const parent = path.parentElement
        if (parent) tischNodes.add(parent)
      })
      tischNodes.forEach(node => node.classList.add('svg-tisch'))

      const tafelNodes = new Set()
      tischNodes.forEach(tisch => {
        const parent = tisch.parentElement
        if (parent) tafelNodes.add(parent)
      })
      tafelNodes.forEach(node => node.classList.add('svg-tafel'))
    },
    getTafelNode(el) {
      let node = el.parentElement
      while (node && !node.classList.contains('svg-tafel')) node = node.parentElement
      return node
    },
    getTischNode(el) {
      let node = el.parentElement
      while (node && !node.classList.contains('svg-tisch')) node = node.parentElement
      return node
    },
    getOrderedTischNodes(tafelNode) {
      const tischNodes = Array.from(tafelNode.querySelectorAll('.svg-tisch'))
      const seen = new Map()
      tischNodes.forEach(node => {
        const firstPath = node.querySelector('path[id]')
        if (!firstPath) return
        const prefix = firstPath.getAttribute('id').split('-')[0]
        const order = parseInt(prefix, 10)
        if (!isNaN(order) && !seen.has(order)) seen.set(order, node)
      })
      return Array.from(seen.entries()).sort((a, b) => a[0] - b[0]).map(([, node]) => node)
    }
  }
}
